




import Vue from 'vue'
import Component from 'vue-class-component'

@Component<Heart>({
  props: {
    color1: {
      type: String,
      default : "#F11A1A"
    }
  }
})

export default class Heart extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
